import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import { useState } from 'react'

import { AgreementActionsButton } from '@user/components/Agreements/common/AgreementActionsButton'
import { AgreementHistory } from './AgreementHistory'
import { EmailHistory } from './EmailHistory'
import { IForm } from '@user/store/agreements/typings'

import { ENTITY_TYPES, splitCamelCase } from '@sales-center/common'

import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import Link from '@mui/material/Link'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'

const getStyles = (theme: Theme) => ({
  detailHeader: {
    fontSize: '16px',
    marginBottom: theme.spacing(1),
  },

  drawer: {
    paddingBottom: (theme: Theme) => theme.spacing(0),
    paddingTop: (theme: Theme) => theme.spacing(0),
  },

  viewMore: {
    color: '#1265a9',
    cursor: 'pointer',
  },
})

interface Props {
  canUpdate: boolean
  agreement: IForm
  entityId: number
  entityType: ENTITY_TYPES
  openAgreementCreateDrawer?: () => void
}

export const Row: React.FC<Props> = (props) => {
  const {
    canUpdate,
    agreement,
    entityId,
    entityType,
    openAgreementCreateDrawer,
  } = props
  const { formatDate } = useLocalizationDateFormat()
  const [open, setOpen] = useState(false)

  const getCellStyle = () => {
    return { borderBottom: open ? 'none' : '1px solid #d2d2d2' }
  }

  const getDrawerStyle = () => {
    return { borderBottom: !open ? 'none' : '1px solid #d2d2d2' }
  }
  const styles = getStyles(useTheme())
  return (
    <>
      <TableRow>
        <TableCell component="th" scope="row" style={getCellStyle()}>
          {formatDate(agreement.createdDate)}
        </TableCell>
        <TableCell style={getCellStyle()}>
          <Typography>{agreement.createdBy}</Typography>
        </TableCell>
        <TableCell style={getCellStyle()}>
          <Typography>{agreement.formName}</Typography>
        </TableCell>
        <TableCell style={getCellStyle()}>
          <Typography>
            <i>{splitCamelCase(agreement.status)}</i>
          </Typography>
        </TableCell>
        <TableCell style={getCellStyle()}>
          <Box display="flex" alignItems="center">
            <Link onClick={() => setOpen(!open)} underline="always">
              <Typography sx={styles.viewMore} display="inline">
                {open ? 'Hide' : 'View'} Details
              </Typography>
            </Link>
            <IconButton
              aria-label="expand row"
              color="primary"
              onClick={() => setOpen(!open)}
              size="small"
              data-test-id={`view-agreements-drawer-row-${agreement.id}`}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </Box>
        </TableCell>
        <TableCell style={getCellStyle()}>
          <AgreementActionsButton
            entityId={entityId}
            entityType={entityType}
            id={agreement.id}
            status={agreement.status}
            canUpdate={canUpdate}
            openAgreementCreateDrawer={openAgreementCreateDrawer}
          />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={getDrawerStyle()} sx={styles.drawer} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box>
              <Typography sx={styles.detailHeader}>
                Agreement History
              </Typography>
              <AgreementHistory history={agreement.history} />
            </Box>
            <Box my={2}>
              <Typography sx={styles.detailHeader}>Email History</Typography>
              <EmailHistory agreementId={agreement.id} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  )
}
